import type { ElegantRoute, CustomRoute, RouteKey } from '@elegant-router/types';
import type { RouteRecordRaw } from 'vue-router';
import { generatedRoutes } from '../elegant/routes';
import { layouts, views } from '../elegant/imports';
import { transformElegantRoutesToVueRoutes } from '../elegant/transform';

/**
 * 自定义路由
 * 这些路由不会自动生成，需要手动配置
 */
const customRoutes: CustomRoute[] = [
  {
    name: 'root',
    path: '/',
    component: 'layout.base$view.query'
  },
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403'
  },
  {
    name: 'not-found',
    path: '/:pathMatch(.*)*',
    component: 'layout.blank$view.404'
  },
  {
    name: 'login',
    path: '/login',
    component: 'layout.blank$view.login'
  }
];

/**
 * 合并自定义路由和自动生成的路由
 */
const elegantRoutes: ElegantRoute[] = [...customRoutes, ...generatedRoutes.filter(route => 
  // 过滤掉已经在自定义路由中定义的路由
  !customRoutes.some(cr => cr.name === route.name)
)];

/**
 * 将优雅路由转换为Vue路由
 */
const transformedRoutes = transformElegantRoutesToVueRoutes(elegantRoutes, layouts, views);

// 直接导出转换后的路由
export const routes = transformedRoutes; 